<!-- <div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>
    <button [ngClass]="{ active: selectedTab === 2 }" (click)="selectedTab = 2">
      Unreferenced
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-security-unprocessed *ngSwitchCase="0"></app-security-unprocessed>
      <app-security-processed *ngSwitchCase="1"></app-security-processed>
      <app-security-unreferenced *ngSwitchCase="2"></app-security-unreferenced>
    </ng-container>
  </div>
</div> -->
<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>
    <button [ngClass]="{ active: selectedTab === 2 }" (click)="selectedTab = 2">
      Unreferenced
    </button>
    <button [ngClass]="{ active: selectedTab === 3 }" (click)="selectedTab = 3">
      Issuer With Multiple
        Security Types
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-security-unprocessed
        *ngSwitchCase="0"
        [isActive]="isActive && selectedTab === 0"
      ></app-security-unprocessed>

      <app-security-processed
        *ngSwitchCase="1"
        [isActive]="isActive && selectedTab === 1"
      ></app-security-processed>

      <app-security-unreferenced
        *ngSwitchCase="2"
        [isActive]="isActive && selectedTab === 2"
      ></app-security-unreferenced>

      <app-multiple-security-types
        *ngSwitchCase="3"
        [isActive]="isActive && selectedTab === 3"
      ></app-multiple-security-types>

    </ng-container>
  </div>
</div>
